module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "开票",
      "width": "900px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.invoiceFormData,
      "rules": _vm.invoiceRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.invoiceFormData.id) + " -- " + _vm._s(_vm.invoiceFormData.nickname))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.invoiceFormData.adviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.invoiceFormData.studyAdviserName))])])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票信息：",
      "prop": "content",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.invoiceFormData.content),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "content", $$v)
      },
      expression: "invoiceFormData.content"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票时间：",
      "label-width": 90
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.invoiceTimeChange
    },
    model: {
      value: (_vm.invoiceFormData.invoiceTime),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "invoiceTime", $$v)
      },
      expression: "invoiceFormData.invoiceTime"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开票金额：",
      "prop": "amount",
      "label-width": 90
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "开票金额"
    },
    model: {
      value: (_vm.invoiceFormData.amount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "amount", $$v)
      },
      expression: "invoiceFormData.amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "发票类型：",
      "prop": "state",
      "label-width": 90
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.invoiceFormData.state),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "state", _vm._n($$v))
      },
      expression: "invoiceFormData.state"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("收据")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("普通发票")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("增值税发票")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("服务发票")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "发票号码：",
      "prop": "number",
      "label-width": 90
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "发票号码"
    },
    model: {
      value: (_vm.invoiceFormData.number),
      callback: function($$v) {
        _vm.$set(_vm.invoiceFormData, "number", $$v)
      },
      expression: "invoiceFormData.number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 0 40px 35px"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "620px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("开票")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "test"
    },
    on: {
      "click": _vm.callback
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 1
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("开票记录")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.invoiceTitle,
      "data": _vm.invoiceData,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d5e1015","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/financial/modal/EditInvoiceModal.vue
// module id = 1686
// module chunks = 8